// V1.6 child-facing VIEW GROUPS for the audited nine-phase rover STEM Mission.
// Authored blocks, their order, saved values and completion gates never change.
// Sections describe existing work; they do NOT create new learning steps.
const FOCUS_PHASES = {
  "wind-car-prelude": [
    { id: "briefing", title: "Meet the rescue mission", startsAt: "green-valley-story-prelude", prompt: "Watch or read the briefing, then open the ranger's clue." },
  ],
  "wind-car-wonder": [
    { id: "idea", title: "Choose your first idea", startsAt: "solution-prediction", prompt: "Pick a possible way the rover could move." },
    { id: "theory", title: "Explain your prediction", startsAt: "initial-theory", prompt: "Record your own theory. You can change it after you investigate." },
  ],
  "wind-car-explore": [
    { id: "inspect", title: "Explore the rover", startsAt: "step2-story", prompt: "Inspect the model and collect clues." },
    { id: "predict", title: "Make your prediction", startsAt: "rover-observations", prompt: "Choose what the clues suggest before the explanation." },
    { id: "evidence", title: "Check the evidence", startsAt: "science-rover-video-block", prompt: "Watch the evidence, check your idea, and revise your explanation." },
  ],
  "wind-car-understand": [
    { id: "parts", title: "Investigate the parts", startsAt: "step3-story", prompt: "Compare the virtual parts with your kit and identify their jobs." },
    { id: "power", title: "Trace the power path", startsAt: "power-path", prompt: "Explain how the battery and closed circuit make the motor turn." },
    { id: "air", title: "Observe the air push", startsAt: "step4-story", prompt: "Use the diagram and demonstrations to predict and observe air movement." },
    { id: "reaction", title: "Explain the opposite push", startsAt: "thrust-check", prompt: "Check your evidence, then explain the forces in your own words." },
  ],
  "wind-car-apply": [
    { id: "safety", title: "Get ready safely", startsAt: "step5-story", prompt: "Check the kit, safety rules, and readiness before handling powered parts." },
    { id: "plan", title: "Plan your build", startsAt: "failure-prediction", prompt: "Predict a possible build problem and decide how to prevent it." },
    { id: "install", title: "Use the build guide", startsAt: "installation-pwo-block", prompt: "Keep power disconnected while following the 3D installation guide." },
    { id: "check", title: "Check your rover", startsAt: "wheel-check", prompt: "Inspect the assembly, free wheel movement, and power-off safety." },
  ],
  "wind-car-test-improve": [
    { id: "power", title: "First power check", startsAt: "step7-story", prompt: "Follow the safe diagnostic sequence before changing the circuit." },
    { id: "trial-one", title: "Trial 1: measure", startsAt: "step8-story", prompt: "Predict, run the first fair trial, and record what actually happened." },
    { id: "redesign", title: "Change one thing", startsAt: "step9-story", prompt: "Choose one change and predict its effect before testing." },
    { id: "trial-two", title: "Trial 2: compare", startsAt: "trial2-record", prompt: "Record the second run and compare the two trials." },
  ],
  "wind-car-explain": [
    { id: "evidence", title: "Bring together the evidence", startsAt: "step10-story", prompt: "Review what your experiments actually showed." },
    { id: "report", title: "Present the rescue report", startsAt: "engineer-report", prompt: "Explain how the rover moves using your evidence." },
  ],
  "wind-car-reflect": [
    { id: "reflect", title: "Reflect on your discoveries", startsAt: "reflect-story", prompt: "Look back at how your prediction changed and what you learned." },
  ],
  "wind-car-grow": [
    { id: "finish", title: "Finish the adventure", startsAt: "grow-story", prompt: "Make one final connection, then finish when you are ready." },
    { id: "version-three", title: "Version 3 engineering challenge", startsAt: "after-camp-green-valley-mission", prompt: "Optional: plan and test an improved rover after the main adventure.", optional: true },
  ],
  // Glow City — preserve the progression from the blackout mystery to a
  // physical first light, short-circuit diagnosis, and controlled redesign.
  "conductive-dough-prelude": [
    { id: "case", title: "Open the Glow City case", startsAt: "glow-city-story-prelude", prompt: "Read or watch the blackout story, then reveal the Master Sculptor's message." },
  ],
  "conductive-dough-wonder": [
    { id: "theory", title: "Make your first theory", startsAt: "opening-cause", prompt: "Choose a possible cause, then record what you actually know." },
  ],
  "conductive-dough-explore": [
    { id: "materials", title: "Investigate the dough", startsAt: "step2-story", prompt: "Predict, explore the virtual materials, and explain what carries electricity." },
    { id: "paths", title: "Trace the complete loop", startsAt: "step3-story", prompt: "Explore the two dough paths and explain why their separation matters." },
  ],
  "conductive-dough-understand": [
    { id: "polarity", title: "Investigate the dark LED", startsAt: "step4-story", prompt: "Predict, inspect the LED, and compare the virtual polarity test." },
  ],
  "conductive-dough-apply": [
    { id: "prepare", title: "Prepare the kit safely", startsAt: "step5-story", prompt: "Identify the exact kit parts and check the battery is switched off." },
    { id: "build", title: "Build and test one light", startsAt: "first-light-build", prompt: "Build the first circuit safely and record the result, whether it works or not." },
  ],
  "conductive-dough-test-improve": [
    { id: "short", title: "Find the short circuit", startsAt: "step6-story", prompt: "Predict what happens when paths touch and investigate a safe fix." },
    { id: "wall", title: "Test an insulating wall", startsAt: "step7-story", prompt: "Try a protective wall and compare before-and-after evidence." },
    { id: "landmark", title: "Design the landmark", startsAt: "step8-story", prompt: "Make a plan, build your landmark, and record Trial 1." },
    { id: "improve", title: "Change one thing and retest", startsAt: "step9-story", prompt: "Use Trial 1 evidence, choose one change, then record Trial 2." },
  ],
  "conductive-dough-explain": [
    { id: "explain", title: "Explain the rescue", startsAt: "step10-story", prompt: "Use your actual circuit observations to defend your explanation." },
  ],
  "conductive-dough-reflect": [
    { id: "reflect", title: "Reflect on your investigation", startsAt: "conductive-reflect-story", prompt: "Describe how your thinking changed after testing." },
  ],
  "conductive-dough-grow": [
    { id: "finish", title: "Finish the Glow City mission", startsAt: "conductive-grow-story", prompt: "Make a final connection, then finish your adventure." },
    { id: "aftercamp", title: "Independent Glow City challenge", startsAt: "after-camp-glow-city-mission", prompt: "Optional: design and test another sculpture after the main mission.", optional: true },
  ],

  // Breeze Station — never blur the one-AA Part A beacon and the two-AA
  // Part B motor/fan build, and keep power-off checks close to real work.
  "electric-spiral-prelude": [
    { id: "case", title: "Open the Breeze Station case", startsAt: "breeze-station-story-prelude", prompt: "Watch or read the emergency, then open the engineer's message." },
  ],
  "electric-spiral-wonder": [
    { id: "prediction", title: "Predict what went wrong", startsAt: "opening-cause", prompt: "Record a possible cause before testing either system." },
  ],
  "electric-spiral-explore": [
    { id: "loop", title: "Find the complete circuit", startsAt: "path-story", prompt: "Explore open and closed circuits and explain what a switch changes." },
    { id: "beacon", title: "Build and test Part A", startsAt: "parta-story", prompt: "Use the one-AA beacon kit, check safety, then record your light test." },
  ],
  "electric-spiral-understand": [
    { id: "compare", title: "Compare light and motion", startsAt: "bridge-story", prompt: "Compare the energy paths before moving to the motor kit." },
    { id: "parts", title: "Investigate the Part B components", startsAt: "partb-reveal-story", prompt: "Explore the two-AA Wind Engine materials and identify their jobs." },
  ],
  "electric-spiral-apply": [
    { id: "prepare", title: "Prepare the tower safely", startsAt: "tower-story", prompt: "Use the virtual build guide and complete power-off checks." },
    { id: "check", title: "Build and check the tower", startsAt: "partb-build", prompt: "Assemble the Wind Engine, check mechanics, and record a possible weak point." },
  ],
  "electric-spiral-test-improve": [
    { id: "first", title: "Run the first wind test", startsAt: "wake-story", prompt: "Follow the approved power sequence and record what actually happens." },
    { id: "direction", title: "Compare the direction", startsAt: "reverse-story", prompt: "Switch power off before adjusting leads; then compare fair trials." },
    { id: "diagnose", title: "Diagnose and improve", startsAt: "rescue-story", prompt: "Use the safe diagnostic order, choose one fix, and record the evidence." },
  ],
  "electric-spiral-explain": [
    { id: "report", title: "Explain the Wind Engine", startsAt: "final-story", prompt: "Build the energy chain and defend it with observations." },
  ],
  "electric-spiral-reflect": [
    { id: "reflect", title: "Reflect on Breeze Station", startsAt: "electric-reflect-story", prompt: "Explain how your ideas changed after investigation." },
  ],
  "electric-spiral-grow": [
    { id: "finish", title: "Finish the station rescue", startsAt: "electric-grow-story", prompt: "Apply the learning to a new question, then finish the mission." },
  ],

  // Robot Artist — protect the opening mystery, then separate energy,
  // circuits, and wobble investigations before physical assembly.
  "robot-artist-prelude": [
    { id: "mystery", title: "Study the mysterious artwork", startsAt: "robot-artist-story-prelude", prompt: "Collect clues without guessing the artist's identity yet." },
  ],
  "robot-artist-wonder": [
    { id: "case", title: "Open the next case file", startsAt: "case-update", prompt: "Compare your first theory with the new evidence." },
    { id: "mission", title: "Set the engineering challenge", startsAt: "robot-abilities", prompt: "Identify design requirements before exploring the robot model." },
  ],
  "robot-artist-explore": [
    { id: "parts", title: "Investigate the kit", startsAt: "step3-story", prompt: "Inspect the parts and their roles before building anything." },
    { id: "predict", title: "Predict what the mystery part does", startsAt: "mystery-weight-hypothesis", prompt: "Make an evidence-based prediction and ask your own question." },
  ],
  "robot-artist-understand": [
    { id: "energy", title: "Trace the energy", startsAt: "step4-story", prompt: "Identify the energy inputs and outputs before exploring the motor." },
    { id: "circuit", title: "Investigate the circuit", startsAt: "step5-story", prompt: "Explore a closed circuit and safely check the real connections." },
    { id: "motion", title: "Investigate the wobble", startsAt: "step6-story", prompt: "Observe how an off-center weight can change the motion." },
  ],
  "robot-artist-apply": [
    { id: "guide", title: "Use the assembly guide", startsAt: "step7-story", prompt: "Follow the safety and installation guidance before powering up." },
    { id: "test", title: "Run the first art test", startsAt: "launch-prediction", prompt: "Predict the pattern and record what your robot really drew." },
  ],
  "robot-artist-test-improve": [
    { id: "compare", title: "Review the first artwork", startsAt: "step8-story", prompt: "Compare the first results and choose one change." },
    { id: "trial", title: "Test the redesign", startsAt: "friction-station", prompt: "Record the next trial and explain what the difference shows." },
  ],
  "robot-artist-explain": [
    { id: "systems", title: "Bring the system together", startsAt: "step9-story", prompt: "Review energy, circuit, and motion evidence." },
    { id: "explain", title: "Defend your explanation", startsAt: "circuit-defense", prompt: "Explain how your drawing result follows from what you tested." },
  ],
  "robot-artist-reflect": [
    { id: "reflect", title: "Reflect on your art investigation", startsAt: "robot-reflect-story", prompt: "Review your first idea and what the real drawings taught you." },
  ],
  "robot-artist-grow": [
    { id: "gallery", title: "Finish the robot art gallery", startsAt: "step10-story", prompt: "Present your artwork and evidence, then finish the mission." },
    { id: "aftercamp", title: "Independent art studio", startsAt: "after-camp-robot-artist-mission", prompt: "Optional: design and test a new gallery project.", optional: true },
  ],

  // Flood Rescue Bridge keeps its *existing progressive reveal*: focus groups
  // reflect only what the progressive renderer has made visible so far.
  "flood-rescue-prelude": [
    { id: "briefing", title: "Understand the rescue mission", startsAt: "flood-rescue-story-prelude", prompt: "Read the mission and identify a fact before making a design." },
  ],
  "rescue-prediction": [
    { id: "prediction", title: "Make the bridge prediction", startsAt: "wonder-story", prompt: "Predict a number and a reason, then test later." },
  ],
  "flat-bridge-test": [
    { id: "setup", title: "Set up the baseline", startsAt: "explore-story", prompt: "Keep supports, paper, and load method consistent." },
    { id: "observe", title: "Record what really happened", startsAt: "bridge1-record", prompt: "Record the first load test and separate observation from explanation." },
  ],
  "hidden-forces": [
    { id: "evidence", title: "Investigate bridge forces", startsAt: "bridge1-prior-evidence", prompt: "Review your own test, then explore the science videos." },
    { id: "explain", title: "Explain your bridge evidence", startsAt: "bridge1-science-explanation", prompt: "Explain what the forces did using what you actually saw." },
  ],
  "engineer-bridge-two": [
    { id: "plan", title: "Plan one design change", startsAt: "apply-story", prompt: "Use your first test to choose a change and predict its effect." },
  ],
  "fair-rescue-test": [
    { id: "fair", title: "Prepare a fair comparison", startsAt: "fair-test-video", prompt: "Review Bridge 1 evidence and keep test conditions consistent." },
    { id: "test", title: "Test and compare Bridge 2", startsAt: "bridge2-record", prompt: "Record the second trial and compare the two outcomes." },
  ],
  "young-engineer-report": [
    { id: "evidence", title: "Review the bridge evidence", startsAt: "failure-clues-video", prompt: "Review both tests before writing the rescue report." },
    { id: "report", title: "Defend the rescue report", startsAt: "first-failure-explanation", prompt: "Explain the change and its evidence, not just the outcome." },
  ],
  "evidence-reflection": [
    { id: "reflect", title: "Reflect on the bridge rescue", startsAt: "reflection-prior-work", prompt: "Look back at your prediction and what your tests taught you." },
  ],
  "next-variable-mission": [
    { id: "next", title: "Choose the next engineering question", startsAt: "real-bridges-video", prompt: "Connect bridge science to a fair next experiment." },
  ],

};

// Short repeated safety reminders are shown only when earlier preparation
// content is collapsed. These repeat authored precautions; they do not add
// a new gate or authorize a child to operate a kit without supervision.
const FOCUS_SAFETY_REMINDERS = {
  "wind-car-apply": "Safety reminder: Switch power OFF before adjusting the rover; keep fingers, hair, and clothing clear of the propeller.",
  "wind-car-test-improve": "Safety reminder: Switch power OFF before adjusting the rover; keep fingers, hair, and clothing clear of the propeller.",
  "conductive-dough-apply": "Safety reminder: Switch the supplied four-AA holder OFF before adjusting dough, leads, or LEDs. Keep paths separate.",
  "conductive-dough-test-improve": "Safety reminder: Switch the supplied four-AA holder OFF before changing the circuit. Do not short the battery holder.",
  "electric-spiral-explore": "Safety reminder: Disconnect power before changing Part A wiring; use only the specified one-AA beacon kit.",
  "electric-spiral-apply": "Safety reminder: Switch power OFF before changing Part B wiring or assembly. Use the specified two-AA source.",
  "electric-spiral-test-improve": "Safety reminder: Switch power OFF before reversing leads or adjusting the fan; keep fingers clear of moving parts.",
  "robot-artist-apply": "Safety reminder: Switch power OFF before adjusting the motor, battery connections, or moving robot parts.",
  "robot-artist-test-improve": "Safety reminder: Switch power OFF before changing the off-center weight, motor, or robot connections.",
  "flat-bridge-test": "Safety reminder: Use stable supports and small non-breakable loading objects; stop if anything becomes unstable.",
  "fair-rescue-test": "Safety reminder: Keep the supports and load method consistent, and stop if the test setup becomes unstable.",
};

export const getJourneyFocusGroups = (page, completionState, visibleBlocks) => {
  const blocks = Array.isArray(visibleBlocks) ? visibleBlocks : [];
  const spec = FOCUS_PHASES[page?.step_id];
  if (!spec || !page?.blocks?.some((block) => block?.self_guided_active)) return null;

  const authored = Array.isArray(page?.blocks) ? page.blocks : [];
  const starts = spec.map((group) => authored.findIndex((block) => block?.id === group.startsAt));
  // Fail open if an authoring edit invalidates a boundary. This component may
  // organize the original page, but must never reinterpret its activities.
  if (starts[0] !== 0 || starts.some((start, index) =>
    start < 0 || (index > 0 && start <= starts[index - 1]))) return null;

  const authoredIds = new Set(authored.map((block) => block?.id));
  const visibleIds = new Set(blocks.map((block) => block?.id));
  if (blocks.some((block) => !authoredIds.has(block?.id))) return null;
  // Preserve every block *currently exposed* by the existing progressive
  // implementation. In particular, Flood Rescue controls visibility before
  // this view-only grouping runs; it still owns the reveal boundaries.
  const required = Array.isArray(completionState?.items) ? completionState.items : [];
  const groups = spec.map((config, index) => {
    const authoredSlice = authored.slice(starts[index], starts[index + 1] ?? authored.length);
    const groupBlocks = authoredSlice.filter((block) => visibleIds.has(block?.id));
    const blockIds = new Set(authoredSlice.map((block) => block?.id));
    const gates = required.filter((item) => blockIds.has(item.targetBlockId));
    return {
      ...config,
      blocks: groupBlocks,
      completed: gates.filter((item) => item.complete).length,
      total: gates.length,
      complete: gates.length > 0 && gates.every((item) => item.complete),
    };
  });

  // If the renderer is progressively revealing content, do not show
  // irrelevant empty future sections. The original visibility rules are
  // unchanged and future groups appear when their content becomes visible.
  const displayed = groups.filter((group) => group.blocks.length > 0);
  if (displayed.flatMap((group) => group.blocks.map((block) => block.id)).join("\u0000") !==
      blocks.map((block) => block.id).join("\u0000")) return null;

  const targetBlockId = completionState?.firstIncomplete?.targetBlockId;
  const targetIndex = displayed.findIndex((group) =>
    group.blocks.some((block) => block?.id === targetBlockId));
  // If the next required block isn't visible, let the original renderer
  // explain what to do rather than concealing it behind a disclosure.
  if (targetBlockId && targetIndex < 0) return null;
  const lastRequiredIndex = displayed.reduce((last, group, index) =>
    group.optional ? last : index, 0);
  const activeIndex = targetIndex >= 0 ? targetIndex : lastRequiredIndex;
  return {
    groups: displayed,
    activeIndex,
    safetyReminder: activeIndex > 0 ? (FOCUS_SAFETY_REMINDERS[page?.step_id] || null) : null,
  };
};
